import { SetPermissionRequest } from '@quadminds/client-apis/agents';
import { toast } from '@quadminds/mindkit';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agentsApi } from '../services/agents-api.service';

const useSetPermissions = (onClose: () => void) => {
    const queryClient = useQueryClient();
    const setPermissionsMutation = useMutation({
        mutationKey: ['set-permissions'],
        mutationFn: async (setPermissionValues: SetPermissionRequest) =>
            agentsApi.updateDatePermissions(setPermissionValues),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['document-permissions', variables.document_id] });
            queryClient.invalidateQueries({ queryKey: ['documents'] });
            onClose();
            toast({
                title: 'Permisos Actualizados',
                description: 'Permisos actualizados correctamente.',
                variant: 'default',
            });
        },
        onError: () => {
            toast({
                title: 'Error',
                description: 'No se pudieron actualizar los permisos.',
                variant: 'destructive',
            });
        },
    });

    return {
        setPermissionsMutation,
    };
};

export default useSetPermissions;
